import { useEffect } from "react"
import { useLocation } from "@reach/router"
import {
  isCredentialBearingPath,
  omitCredentialQueryParams,
} from "src/utils/credentialBearingRoutes"
import { screen } from "src/utils/mixpanel"

/**
 * Records a Mixpanel page view whenever the route or search params change.
 * Renders nothing; use once inside the root layout.
 */
const MixpanelPageView = () => {
  const location = useLocation()
  const pathname = location?.pathname
  const search = location?.search

  useEffect(() => {
    if (typeof window === "undefined" || !pathname) return
    // These routes put JWTs/service tokens in the query string; skip so we
    // don't send them as event props or via Mixpanel's $current_url.
    if (isCredentialBearingPath(pathname)) return
    const searchParams = search
      ? Object.fromEntries(new URLSearchParams(search).entries())
      : {}
    const props = {
      ...omitCredentialQueryParams(searchParams),
      ...(document.referrer ? { referrer: document.referrer } : {}),
    }
    screen(pathname, props)
  }, [pathname, search])

  return null
}

export default MixpanelPageView
